import { FC } from "react";
import classNames from "classnames";
import { ITitleProps } from "./types";
import styles from "./Title.module.css";

const Title: FC<ITitleProps> = ({ label, className }) => {
  return <h2 className={classNames(styles["title"], className)}>{label}</h2>;
};

export default Title;
